import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import EzChipMui from "./Implementations/EzChipMui.es.js";
const EzChip = forwardRef(
  ({ label, color = "common.grey130", icon, onClick, onDelete, size = "medium", variant = "filled" }, ref) => /* @__PURE__ */ jsx(
    EzChipMui,
    {
      ref,
      label,
      color,
      icon,
      onClick,
      onDelete,
      size,
      variant
    }
  )
);
EzChip.displayName = "EzChip";
export {
  EzChip as default
};
//# sourceMappingURL=EzChip.es.js.map
